import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import "./style.css";
import { _, pick } from "../../model/utils";

const ConfirmationHeader = ({ email }) => {
  const createLine = (r, i) => (
    <p styleName="paragraph" key={i}>
      {String.format(r, email)}
    </p>
  );
  return (
    <div className="row">
      <div className="col-12">
        <h1 styleName="top-title">{_.confirmationTopTitle}</h1>
      </div>
      <div className="col-12">
        <p styleName="subtitle">{_.confirmationSubtitle}</p>
      </div>
      <div className="col-12 col-md-6">
        {_.confirmationLeftColumn.map(createLine)}
      </div>
      <div className="col-12 col-md-6">
        {_.confirmationRightColumn.map(createLine)}
      </div>
    </div>
  );
};

ConfirmationHeader.propTypes = {
  email: PropTypes.string.isRequired
};

export default connect(pick(["email"]))(ConfirmationHeader);
